(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["DYU-Featured-Product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dyu-featured-product')) {
    customElements.define('dyu-featured-product', class DyuFeaturedProduct extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.events?.abort();
      }

      initialize() {
        this.events?.abort();
        const dataElement = this.querySelector('[data-variant-data]');
        if (!dataElement) return;
        try {
          this.variantData = JSON.parse(dataElement.textContent);
        } catch (error) {
          console.warn('DYU Featured Product: invalid variant data.', error);
          return;
        }
        this.variants = new Map(this.variantData.variants.map(variant => [String(variant.id), variant]));
        this.events = new AbortController();
        this.addEventListener('click', event => {
          const swatch = event.target.closest('button[data-variant-id]');
          if (!swatch || !this.contains(swatch) || swatch.disabled) return;
          this.selectVariant(swatch.dataset.variantId, true);
        }, { signal: this.events.signal });
        this.selectVariant(this.variantData.initialId, false);
      }

      selectVariant(id, announce) {
        const variant = this.variants.get(String(id));
        if (!variant) return;
        this.dataset.variantId = String(variant.id);
        const input = this.querySelector('[data-selected-variant]');
        if (input) {
          input.value = String(variant.id);
        }
        this.querySelectorAll('button[data-variant-id]').forEach(swatch => {
          swatch.setAttribute('aria-pressed', String(swatch.dataset.variantId === String(variant.id)));
        });
        const colorLabel = this.querySelector('[data-selected-color]');
        if (colorLabel) colorLabel.textContent = variant.color;
        const sale = this.querySelector('[data-sale-price]');
        if (sale) sale.textContent = variant.price;
        const compare = this.querySelector('[data-compare-price]');
        if (compare) compare.textContent = variant.compare || '';
        const compareGroup = this.querySelector('[data-compare-group]');
        if (compareGroup) compareGroup.hidden = !variant.compare;
        const priceLabel = this.querySelector('[data-price-label]');
        if (priceLabel) priceLabel.textContent = variant.compare ? this.variantData.saleLabel : this.variantData.regularLabel;
        const availability = this.querySelector('[data-availability]');
        if (availability) availability.hidden = variant.available;
        this.updateImage(variant.image);
        this.updateProductLink(variant.id);
        if (announce) {
          if (input) input.dispatchEvent(new Event('change', { bubbles: true }));
          const status = this.querySelector('[data-variant-status]');
          if (status) status.textContent = [variant.color, variant.price, variant.available ? '' : this.dataset.soldOutLabel].filter(Boolean).join(' — ');
          this.dispatchEvent(new CustomEvent('dyu:variant-change', {
            bubbles: true,
            detail: { sectionId: this.dataset.sectionId, variantId: String(variant.id), variant }
          }));
        }
      }

      updateImage(imageData) {
        const media = this.querySelector('[data-product-media]');
        if (!media) return;
        let image = media.querySelector('img');
        if (!imageData) {
          if (image) image.hidden = true;
          return;
        }
        if (!image) {
          image = document.createElement('img');
          image.className = 'dyu-fp__image';
          image.decoding = 'async';
          media.replaceChildren(image);
        }
        image.hidden = false;
        image.alt = imageData.alt || '';
        image.width = imageData.width;
        image.height = imageData.height;
        // Update srcset together with src so a browser cannot retain the previous color.
        if (image.getAttribute('src') !== imageData.src) {
          image.removeAttribute('srcset');
          if (imageData.srcset) {
            image.srcset = imageData.srcset;
            image.sizes = '(min-width: 1600px) 800px, (min-width: 750px) 55vw, calc(100vw - 56px)';
          } else {
            image.removeAttribute('sizes');
          }
          image.src = imageData.src;
        }
      }

      updateProductLink(variantId) {
        const link = this.querySelector('[data-product-link]');
        if (!link || !this.dataset.productUrl) return;
        try {
          const productUrl = new URL(this.dataset.productUrl, window.location.origin);
          const buttonUrl = new URL(this.dataset.buttonUrl || productUrl.href, window.location.origin);
          // Only add variant to links for this product; campaign links retain their destination.
          if (buttonUrl.origin === productUrl.origin && buttonUrl.pathname.replace(/\/$/, '') === productUrl.pathname.replace(/\/$/, '')) {
            buttonUrl.searchParams.set('variant', String(variantId));
          }
          link.href = buttonUrl.href;
        } catch (error) {
          console.warn('DYU Featured Product: invalid product link.', error);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["DYU-featured-product-custom-image"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dyu-featured-product')) {
    customElements.define('dyu-featured-product', class DyuFeaturedProduct extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.events?.abort();
      }

      initialize() {
        this.events?.abort();
        const dataElement = this.querySelector('[data-variant-data]');
        if (!dataElement) return;
        try {
          this.variantData = JSON.parse(dataElement.textContent);
        } catch (error) {
          console.warn('DYU Featured Product: invalid variant data.', error);
          return;
        }
        this.variants = new Map(this.variantData.variants.map(variant => [String(variant.id), variant]));
        this.events = new AbortController();
        this.addEventListener('click', event => {
          const swatch = event.target.closest('button[data-variant-id]');
          if (!swatch || !this.contains(swatch) || swatch.disabled) return;
          this.selectVariant(swatch.dataset.variantId, true);
        }, { signal: this.events.signal });
        this.selectVariant(this.variantData.initialId, false);
      }

      selectVariant(id, announce) {
        const variant = this.variants.get(String(id));
        if (!variant) return;
        this.dataset.variantId = String(variant.id);
        const input = this.querySelector('[data-selected-variant]');
        if (input) {
          input.value = String(variant.id);
        }
        this.querySelectorAll('button[data-variant-id]').forEach(swatch => {
          swatch.setAttribute('aria-pressed', String(swatch.dataset.variantId === String(variant.id)));
        });
        const colorLabel = this.querySelector('[data-selected-color]');
        if (colorLabel) colorLabel.textContent = variant.color;
        const sale = this.querySelector('[data-sale-price]');
        if (sale) sale.textContent = variant.price;
        const compare = this.querySelector('[data-compare-price]');
        if (compare) compare.textContent = variant.compare || '';
        const compareGroup = this.querySelector('[data-compare-group]');
        if (compareGroup) compareGroup.hidden = !variant.compare;
        const priceLabel = this.querySelector('[data-price-label]');
        if (priceLabel) priceLabel.textContent = variant.compare ? this.variantData.saleLabel : this.variantData.regularLabel;
        const availability = this.querySelector('[data-availability]');
        if (availability) availability.hidden = variant.available;
        this.updateImage(variant.image);
        this.updateProductLink(variant.id);
        if (announce) {
          if (input) input.dispatchEvent(new Event('change', { bubbles: true }));
          const status = this.querySelector('[data-variant-status]');
          if (status) status.textContent = [variant.color, variant.price, variant.available ? '' : this.dataset.soldOutLabel].filter(Boolean).join(' — ');
          this.dispatchEvent(new CustomEvent('dyu:variant-change', {
            bubbles: true,
            detail: { sectionId: this.dataset.sectionId, variantId: String(variant.id), variant }
          }));
        }
      }

      updateImage(imageData) {
        const media = this.querySelector('[data-product-media]');
        if (!media) return;
        const host = media.querySelector('[data-media-image-host]') || media;
        const frame = host.closest('.dyu-fp__media-frame') || host;
        let image = host.querySelector('img');
        if (!imageData) {
          if (image) image.hidden = true;
          return;
        }
        if (!image) {
          image = document.createElement('img');
          image.className = 'dyu-fp__image';
          image.decoding = 'async';
          const placeholder = host.querySelector('.dyu-fp__placeholder');
          if (placeholder) placeholder.replaceWith(image);
          else host.insertBefore(image, host.firstChild);
        }
        image.hidden = false;
        image.alt = imageData.alt || '';
        image.width = imageData.width;
        image.height = imageData.height;
        const ratio = Number(imageData.width) / Number(imageData.height);
        if (Number.isFinite(ratio) && ratio > 0) {
          const sectionStyles = getComputedStyle(this);
          const desktopHeight = parseFloat(sectionStyles.getPropertyValue('--dyu-fp-image-max-height')) || Number(imageData.height);
          const mobileHeight = parseFloat(sectionStyles.getPropertyValue('--dyu-fp-mobile-image-max-height')) || Number(imageData.height);
          frame.style.setProperty('--dyu-fp-image-ratio', String(ratio));
          frame.style.setProperty('--dyu-fp-image-frame-max-width', `${desktopHeight * ratio}px`);
          frame.style.setProperty('--dyu-fp-mobile-image-frame-max-width', `${mobileHeight * ratio}px`);
        }
        // Update srcset together with src so a browser cannot retain the previous color.
        if (image.getAttribute('src') !== imageData.src) {
          image.removeAttribute('srcset');
          if (imageData.srcset) {
            image.srcset = imageData.srcset;
            image.sizes = '(min-width: 1600px) 900px, (min-width: 750px) 60vw, calc(100vw - 72px)';
          } else {
            image.removeAttribute('sizes');
          }
          image.src = imageData.src;
        }
      }

      updateProductLink(variantId) {
        const link = this.querySelector('[data-product-link]');
        if (!link || !this.dataset.productUrl) return;
        try {
          const productUrl = new URL(this.dataset.productUrl, window.location.origin);
          const buttonUrl = new URL(this.dataset.buttonUrl || productUrl.href, window.location.origin);
          // Only add variant to links for this product; campaign links retain their destination.
          if (buttonUrl.origin === productUrl.origin && buttonUrl.pathname.replace(/\/$/, '') === productUrl.pathname.replace(/\/$/, '')) {
            buttonUrl.searchParams.set('variant', String(variantId));
          }
          link.href = buttonUrl.href;
        } catch (error) {
          console.warn('DYU Featured Product: invalid product link.', error);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["DYU-hero-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dyu-hero-carousel')) {
    customElements.define('dyu-hero-carousel', class DyuHeroCarousel extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        clearTimeout(this.timer);
        this.events?.abort();
        this.observer?.disconnect();
      }

      initialize() {
        this.events?.abort();
        this.observer?.disconnect();
        clearTimeout(this.timer);
        this.slides = Array.from(this.querySelectorAll('[data-dyu-slide]'));
        if (!this.slides.length) return;
        this.dots = Array.from(this.querySelectorAll('[data-dyu-dot]'));
        this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
        this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.interval = Math.max(2000, Number(this.dataset.interval) || 5000);
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = !this.autoplay || this.motion.matches;
        this.hovered = false;
        this.touching = false;
        this.inViewport = true;
        this.editorPaused = false;
        this.gesture = null;
        this.suppressClick = false;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const controls = this.querySelector('[data-dyu-controls]');
        if (controls) controls.hidden = this.slides.length < 2;

        this.addEventListener('click', event => {
          if (this.suppressClick && event.detail !== 0) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.suppressClick = false;
          }
        }, { ...options, capture: true });
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-dyu-next')) this.goTo(this.index + 1, true);
          else if (button.hasAttribute('data-dyu-prev')) this.goTo(this.index - 1, true);
          else if (button.hasAttribute('data-dyu-dot')) this.goTo(Number(button.dataset.dyuDot), true);
          else if (button.hasAttribute('data-dyu-rotation')) {
            this.userPaused = !this.userPaused;
            this.refreshRotation();
          }
        }, options);
        this.addEventListener('focusin', event => {
          // Focusing the rotation control must preserve its intended play/pause action.
          if (event.target.closest('[data-dyu-rotation]')) return;
          this.userPaused = true;
          this.refreshRotation();
        }, options);
        this.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.refreshRotation();
        }, options);
        this.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = false;
          this.refreshRotation();
        }, options);
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          if (event.target.closest('a, input, textarea, select, [contenteditable]')) return;
          event.preventDefault();
          this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
          if (event.target.hasAttribute('data-dyu-dot')) this.dots[this.index]?.focus();
        }, options);

        this.addEventListener('pointerdown', event => {
          this.suppressClick = false;
          if (event.pointerType === 'mouse' || !event.isPrimary || this.slides.length < 2) return;
          if (event.target.closest('button, input, textarea, select, [contenteditable]')) return;
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.touching = true;
          this.refreshRotation();
        }, options);
        this.addEventListener('pointerup', event => {
          if (!this.gesture || this.gesture.id !== event.pointerId) return;
          const dx = event.clientX - this.gesture.x;
          const dy = event.clientY - this.gesture.y;
          this.gesture = null;
          this.touching = false;
          if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            this.suppressClick = true;
            this.goTo(this.index + (dx < 0 ? 1 : -1), true);
          } else this.refreshRotation();
        }, options);
        this.addEventListener('pointercancel', () => {
          this.gesture = null;
          this.touching = false;
          this.refreshRotation();
        }, options);
        document.addEventListener('visibilitychange', () => this.refreshRotation(), options);
        this.motion.addEventListener('change', event => {
          if (event.matches) this.userPaused = true;
          this.refreshRotation();
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const selected = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
          if (selected < 0) return;
          this.editorPaused = true;
          this.goTo(selected, false);
        }, options);
        this.addEventListener('shopify:block:deselect', () => {
          this.editorPaused = false;
          this.refreshRotation();
        }, options);
        document.addEventListener('shopify:section:select', event => {
          if (event.detail?.sectionId !== this.dataset.sectionId) return;
          this.editorPaused = true;
          this.goTo(0, false);
        }, options);
        document.addEventListener('shopify:section:deselect', event => {
          if (event.detail?.sectionId !== this.dataset.sectionId) return;
          this.editorPaused = false;
          this.refreshRotation();
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inViewport = entries[0].isIntersecting;
            this.refreshRotation();
          }, { threshold: 0.1 });
          this.observer.observe(this);
        }
        this.goTo(this.index, false);
      }

      goTo(nextIndex, manual = false) {
        if (!Number.isFinite(nextIndex)) return;
        this.index = ((nextIndex % this.slides.length) + this.slides.length) % this.slides.length;
        if (manual) this.userPaused = true;
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        this.dots.forEach((dot, index) => {
          if (index === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        // Warm up only the active slide and the next slide's responsive image.
        [this.index, (this.index + 1) % this.slides.length].forEach(index => {
          const image = this.slides[index].querySelector('img');
          if (image) image.loading = 'eager';
        });
        if (manual) {
          const status = this.querySelector('[data-dyu-status]');
          if (status) status.textContent = this.slides[this.index].getAttribute('aria-label');
        }
        this.refreshRotation();
      }

      refreshRotation() {
        clearTimeout(this.timer);
        const requested = this.autoplay && !this.userPaused;
        const button = this.querySelector('[data-dyu-rotation]');
        if (button) {
          button.setAttribute('aria-label', requested ? button.dataset.pauseLabel : button.dataset.playLabel);
          const pauseIcon = button.querySelector('[data-dyu-pause-icon]');
          const playIcon = button.querySelector('[data-dyu-play-icon]');
          if (pauseIcon) pauseIcon.hidden = !requested;
          if (playIcon) playIcon.hidden = requested;
        }
        // Announce manual changes; avoid announcements during automatic rotation.
        this.querySelector('[data-dyu-slides]')?.setAttribute('aria-live', requested ? 'off' : 'polite');
        if (!requested || this.hovered || this.touching || !this.inViewport || this.editorPaused || document.hidden) return;
        this.timer = setTimeout(() => this.goTo(this.index + 1, false), this.interval);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["DYU-product-sale-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dyu-sale-grid')) {
    customElements.define('dyu-sale-grid', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.items = Array.from(this.querySelectorAll('[data-carousel-item]'));
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
        this.previousButton = this.querySelector('[data-carousel-prev]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.activeIndex = 0;
        this.scrollFrame = null;

        this.onClick = this.handleClick.bind(this);
        this.onScroll = this.handleScroll.bind(this);
        this.onResize = this.updateCarousel.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);

        this.addEventListener('click', this.onClick);
        if (this.track) this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.updateCarousel();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      }

      handleClick(event) {
        const swatch = event.target.closest('.dyu-sale-card__swatch[data-variant-id]');
        if (swatch && this.contains(swatch)) {
          this.selectVariant(swatch);
          return;
        }

        const previous = event.target.closest('[data-carousel-prev]');
        if (previous && this.contains(previous)) {
          this.goToSlide(this.activeIndex - 1);
          return;
        }

        const next = event.target.closest('[data-carousel-next]');
        if (next && this.contains(next)) {
          this.goToSlide(this.activeIndex + 1);
          return;
        }

        const dot = event.target.closest('[data-carousel-dot]');
        if (dot && this.contains(dot)) {
          this.goToSlide(Number(dot.dataset.carouselDot));
        }
      }

      selectVariant(swatch) {
        const card = swatch.closest('[data-product-card]');
        if (!card) return;

        card.querySelectorAll('.dyu-sale-card__swatch[data-variant-id]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === swatch));
        });

        const image = card.querySelector('.dyu-sale-card__image');
        if (image && swatch.dataset.imageSrc) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = swatch.dataset.imageSrc;
          image.alt = swatch.dataset.imageAlt || '';
          if (swatch.dataset.imageWidth) image.width = Number(swatch.dataset.imageWidth);
          if (swatch.dataset.imageHeight) image.height = Number(swatch.dataset.imageHeight);
        }

        const price = card.querySelector('[data-current-price]');
        if (price) price.textContent = swatch.dataset.price || '';

        const compare = card.querySelector('[data-compare-price]');
        if (compare) {
          compare.textContent = swatch.dataset.compare || '';
          compare.hidden = !swatch.dataset.compare;
        }

        const discount = card.querySelector('[data-discount-badge][data-auto="true"]');
        if (discount) {
          discount.textContent = swatch.dataset.discount || '';
          discount.hidden = !swatch.dataset.discount;
        }

        const installment = card.querySelector('[data-installment-display]');
        if (installment) {
          installment.textContent = swatch.dataset.variantInstallment || '';
          installment.hidden = !swatch.dataset.variantInstallment;
        }

        const variantInput = card.querySelector('[data-selected-variant]');
        if (variantInput) variantInput.value = swatch.dataset.variantId || '';

        const button = card.querySelector('[data-card-button]');
        if (button) {
          const available = swatch.dataset.available === 'true';
          if (swatch.dataset.buttonUrl) button.href = swatch.dataset.buttonUrl;
          button.setAttribute('aria-disabled', String(!available));
          button.textContent = available ? button.dataset.defaultText : button.dataset.soldOutText;
        }

        const titleLink = card.querySelector('[data-card-title-link]');
        if (titleLink && swatch.dataset.productUrl) titleLink.href = swatch.dataset.productUrl;
      }

      handleScroll() {
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.updateCarousel());
      }

      updateCarousel() {
        if (!this.track || !this.items.length) return;
        const trackLeft = this.track.getBoundingClientRect().left;
        let closestIndex = 0;
        let closestDistance = Infinity;
        this.items.forEach((item, index) => {
          const distance = Math.abs(item.getBoundingClientRect().left - trackLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        this.activeIndex = closestIndex;
        this.dots.forEach((dot, index) => {
          dot.setAttribute('aria-current', String(index === closestIndex));
        });
        if (this.previousButton) this.previousButton.disabled = closestIndex === 0;
        if (this.nextButton) this.nextButton.disabled = closestIndex === this.items.length - 1;
      }

      goToSlide(index, behavior = 'smooth') {
        if (!this.track || !this.items.length) return;
        const targetIndex = Math.max(0, Math.min(index, this.items.length - 1));
        const target = this.items[targetIndex];
        const left = target.offsetLeft - this.items[0].offsetLeft;
        this.track.scrollTo({ left, behavior });
      }

      handleBlockSelect(event) {
        const item = event.target && event.target.closest ? event.target.closest('[data-carousel-item]') : null;
        if (!item || !this.contains(item)) return;
        const index = this.items.indexOf(item);
        if (index >= 0) this.goToSlide(index, 'smooth');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    customElements.define('sticky-header-mobile', StickyHeaderMobile);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
            if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                $('.vertical-menu').addClass('vertical-menu__hide');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
          if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
              if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
                $('.vertical-menu').removeClass('vertical-menu__hide');
              }
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
